import React from "react";

export default function Paginator({
  currentPage,
  totalPages,
  handlePageChange,
  itemsPerPage = 10,
}) {
  const MAX_PAGES_TO_SHOW = 5;
  const pagesBuffer = Math.floor(MAX_PAGES_TO_SHOW / 2);

  const firstPageIndex = Math.max(0, currentPage - pagesBuffer);
  const lastPageIndex = Math.min(totalPages - 1, currentPage + pagesBuffer);

  const pageNumbers = Array.from(
    { length: lastPageIndex - firstPageIndex + 1 },
    (_, index) => index + firstPageIndex
  );

  // --- ESTILOS BASE REUTILIZABLES ---
  const containerStyle = { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '16px', flexWrap: 'wrap' };
  const textStyle = { color: '#9CA3AF', fontSize: '14px', margin: 0, display: 'flex', alignItems: 'center' };
  const numberStyle = { fontSize: '14px', marginRight: '16px', color: '#374151', margin: '0 16px 0 8px', display: 'flex', alignItems: 'center' };
  
  const btnBase = {
    margin: '0 4px',
    padding: '6px 14px',
    borderRadius: '6px',
    border: 'none',
    fontSize: '14px',
    fontFamily: 'inherit',
    transition: 'all 0.2s ease',
  };

  return (
    <div style={containerStyle}>
      <p style={textStyle}>Filas por página</p>
      <p style={numberStyle}>{itemsPerPage}</p>

      {/* Flecha Anterior */}
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 0 || totalPages === 0}
        style={{
          ...btnBase,
          backgroundColor: 'transparent',
          color: currentPage === 0 || totalPages === 0 ? '#D1D5DB' : '#374151',
          cursor: currentPage === 0 || totalPages === 0 ? 'not-allowed' : 'pointer'
        }}
      >
        &lt;
      </button>

      {/* Primera página y puntos si estamos muy lejos */}
      {currentPage > pagesBuffer && (
        <>
          <button
            onClick={() => handlePageChange(0)}
            style={{ ...btnBase, backgroundColor: '#E5E7EB', color: '#1F2937', cursor: 'pointer' }}
          >
            1
          </button>
          {currentPage > pagesBuffer + 1 && (
            <span style={{ margin: '0 4px', padding: '6px 4px', color: '#6B7280', userSelect: 'none' }}>...</span>
          )}
        </>
      )}

      {/* Números dinámicos */}
      {pageNumbers.map((page) => (
        <button
          key={page}
          onClick={() => handlePageChange(page)}
          style={{
            ...btnBase,
            backgroundColor: currentPage === page ? '#EAB308' : '#E5E7EB', // Amarillo si es el actual, Gris si no
            color: currentPage === page ? 'white' : '#1F2937',
            fontWeight: currentPage === page ? '600' : 'normal',
            cursor: 'pointer'
          }}
        >
          {page + 1}
        </button>
      ))}

      {/* Última página y puntos si estamos lejos del final */}
      {currentPage < totalPages - 1 - pagesBuffer && (
        <>
          {currentPage < totalPages - 2 - pagesBuffer && (
            <span style={{ margin: '0 4px', padding: '6px 4px', color: '#6B7280', userSelect: 'none' }}>...</span>
          )}
          <button
            onClick={() => handlePageChange(totalPages - 1)}
            style={{ ...btnBase, backgroundColor: '#E5E7EB', color: '#1F2937', cursor: 'pointer' }}
          >
            {totalPages}
          </button>
        </>
      )}

      {/* Flecha Siguiente */}
      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages - 1 || totalPages === 0}
        style={{
          ...btnBase,
          backgroundColor: 'transparent',
          color: currentPage === totalPages - 1 || totalPages === 0 ? '#D1D5DB' : '#374151',
          cursor: currentPage === totalPages - 1 || totalPages === 0 ? 'not-allowed' : 'pointer'
        }}
      >
        &gt;
      </button>
    </div>
  );
}